<template>
  <div id="proList">
    <p class="title">创建新产品
      <!--<router-link to="/createPro">-->
        <el-button type="primary" class="pull-right el-button-small" round size="small" @click="routeB">创建产品</el-button>
      <!--</router-link>-->
    </p>
    <div id="proListMain">
      <div class="proTable">
        <template>
          <el-table
            :data="tableData"
            style="width: 100%">
            <el-table-column
              prop="client_name"
              align="center"
              label="产品名称">
            </el-table-column>
            <el-table-column
              prop="client_id"
              align="center"
              label="产品ID">
            </el-table-column>
            <el-table-column
              align="center"
              label="产品类型">
              <template slot-scope="scope">
                {{scope.row.open_product_type}}
              </template>
            </el-table-column>
            <el-table-column
              prop="create_time"
              align="center"
              label="时间">
            </el-table-column>
            <el-table-column
              align="center"
              label="操作">
              <template slot-scope="scope">
                <router-link :to="'/skillSetting?client_id=' + scope.row.client_id" @click.native="changeState"><el-button type="text" size="mini">编辑</el-button></router-link>
                <!--<el-button type="primary" icon="el-icon-edit" size="mini"></el-button>-->
                <el-button type="text" size="mini" @click="deletePro(scope.row.client_id)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </template>
      </div>
      <!--<div class="block" style="float:right">
        <el-pagination
          :page-size="page.per_page"
          layout="prev, pager, next"
          @current-change="handleCurrentChange"
          :total="page.total">
        </el-pagination>
      </div>-->
    </div>
      <el-dialog
        title="删除"
        :visible.sync="dialogVisible"
        width="30%">
        <span>确定删除该产品信息？</span>
        <span slot="footer" class="dialog-footer">
    <el-button @click="dialogVisible = false">取 消</el-button>
    <el-button type="primary" @click="deletePro1">确 定</el-button>
  </span>
      </el-dialog>
    </div>

</template>
<script>
  import qs from 'qs'
  import {proListApi, deleteProApi} from '@/api/hardIndex.js'
  import {examineApi} from '@/api/index'

  export default {
    data() {
      return {
        tableData: [],
        dialogVisible: false,
        c_page: 1,
        page: {},
        isPass: 0
      }
    },
    created() {
      this.examine()
      this.proList()
    },
    methods: {
      changeState(){
        this.$store.dispatch("changeClientName",'')
      },
      async proList() {
        let res = await proListApi(qs.stringify({page: this.c_page}))
        if (res.data.code == 200) {
          this.tableData = res.data.data
          this.page = res.data.params.page
        } else {
          this.$message.error('当前网络状况异常，请稍后再试')
        }

      },
      deletePro (id) {
        this.dialogVisible = true
        this.clientId = id
      },
      async deletePro1 () {
        this.dialogVisible = false
          let res = await deleteProApi (qs.stringify({'client_id': this.clientId}))
        if (res.data.code == 200) {
            this.$message.success('删除成功')
          this.proList()
        } else {
          if (res.data.errors.data) {
            this.$message.error(res.data.errors.data)
          } else {
            this.$message.error('当前网络状况异常，请稍后再试')
          }
        }
      },
      handleCurrentChange (skip) {
        this.c_page = skip
        this.proList()
      },
      async examine () {
        let res = await examineApi()
        if (res.data.code == 200) {
          if (res.data.data.user_type) {
            this.isPass = res.data.data.status;
            //console.log(res.data);
          }
        }
      },
      routeB () {
        if (this.isPass != 2) {
          this.$message({message: '请先认证开发者信息', type: 'error'})
          return
        }
        this.$router.push('/createPro')
      }
    }
  }
</script>
<style rel="stylesheet/scss" lang="scss">
  #proList {
    width: 100%;
    min-height:100%;
    position: relative;
    background:#fff;
    .el-table__body, .el-table__footer, .el-table__header{
      table-layout: auto;
    }
    .iconfont {
      font-size: 20px;
    }
    padding: 90px 30px 30px 30px;
    p {
      button {
        width: 145px;
        margin-bottom: 20px;
      }
    }
    .title {
      height: 64px;
      line-height: 64px;
      padding-left: 30px;
      font-size: 16px;
      font-weight: 800;
      color: #2e4d79;
      margin-bottom: 30px;
      border-bottom: 1px solid #f5f5f5;
      border-left: 2px solid #010202;
      .pull-right {
        float: right;
        margin-top: 17px;margin-right: 30px;
      }
    }
    .proTable{
      min-height:420px;
      padding: 0 30px 0;
    }
    .el-button-small{
      padding: 9px 15px;
      height: 34px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/hardware/ProductList.vue